import { render, staticRenderFns } from "./SalesManageLogin.vue?vue&type=template&id=8996ea04&"
import script from "./SalesManageLogin.vue?vue&type=script&lang=js&"
export * from "./SalesManageLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports